import 'swiper/swiper-bundle.css';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';

import PropTypes from 'prop-types';
import React from 'react';
import SwiperCore, { Autoplay, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { Link } from '../../Link/Link';
import * as css from './TutorialBanners.module.scss';

// inizialize SwiperCore
SwiperCore.use([Pagination, Autoplay]);

const TutorialBanner = ({ banner }) => {
  return (
    <div
      className={css.banner}
      style={{
        backgroundImage: `url(${banner.heroImage.publicURL})`,
      }}
    >
      <div className={css.boxWrapper}>
        <div className={css.box}>
          <span className={css.title}>{banner.title}</span>
          <p className={css.description}>{banner.description}</p>
          <Link rel="noreferrer" variant="primary" href={banner.slug}>
            Explore
          </Link>
        </div>
      </div>
    </div>
  );
};

TutorialBanner.propTypes = {
  banner: PropTypes.object.isRequired,
};

const TutorialBanners = ({ banners }) => {
  return (
    <Swiper
      modules={[Pagination, Autoplay]}
      spaceBetween={0}
      slidesPerView={1}
      grabCursor={false}
      watchOverflow={false}
      direction={'horizontal'}
      allowTouchMove={false}
      loop={true}
      pagination={{ clickable: true }}
      autoplay={{ delay: 5000, pauseOnMouseEnter: true }}
    >
      {banners.map((banner, i) => {
        return (
          <SwiperSlide key={i}>
            <TutorialBanner banner={banner} />
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
};

TutorialBanners.propTypes = {
  banners: PropTypes.array.isRequired,
};

export default TutorialBanners;
